import { ReactComponent } from './number-3-xl.svg';
export const Number3IconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=number-3-xl.js.map